export const Origins = {
    firstStepCheckout : "21",    
    firstStepRediminPin : "22",    
}